import template from './taskCreatedBy.html';

const TaskCreatedByController = function controller(peopleService) {
  const $ctrl = this;

  $ctrl.$onInit = function init() {
    $ctrl.typeaheadConfigs = {
      editable: true,
      selectOnExact: true,
      selectOnBlur: true,
      focusOnSelect: false,
      appendToBody: true
    };

    // Boolean to enable/disable the input and cancel button
    $ctrl.valueSelected = false;

    peopleService.getUser().then((user) => {
      $ctrl.currentUser = user;

      if ($ctrl.filter.value) {
        const person = {
          username: $ctrl.filter.value
        };
        $ctrl.toggleCreator(person);
      }
    });
  };

  $ctrl.toggleCreator = function toggle(person) {
    const filterValue = person ? person.username : null;
    $ctrl.filter.changeValue(filterValue);

    $ctrl.user = filterValue;
    $ctrl.valueSelected =
      $ctrl.currentUser.username === $ctrl.user ? true : !$ctrl.valueSelected;
  };

  $ctrl.myTasks = function createdByMe() {
    if ($ctrl.currentUser.username && $ctrl.currentUser.username !== $ctrl.user) {
      $ctrl.toggleCreator($ctrl.currentUser);
    }
  };
};


const controllerArr = [
  'peopleService',
  TaskCreatedByController
];

const component = {
  template,
  bindings: {
    filter: '<'
  },
  controller: 'TaskCreatedByController'
};

export default function (ngModule) {
  ngModule.component('taskCreatedBy', component);
  ngModule.controller('TaskCreatedByController', controllerArr);
}
